export enum WindowSize {
    xs = 'xs',
    sm = 'sm',
    md = 'md',
    lg = 'lg'
  }
  